import { render } from "./PreBake.vue?vue&type=template&id=1bc556dc"
import script from "./PreBake.vue?vue&type=script&lang=ts"
export * from "./PreBake.vue?vue&type=script&lang=ts"
script.render = render

export default script